/* istanbul ignore file */
import React from 'react';

import type { MissingTranslationDialogProps } from './MissingTranslationDialog';

const LazyMissingTranslationDialog = React.lazy(() =>
    import(
        /* webpackChunkName: 'missing-translation-dialog' */
        './MissingTranslationDialog'
    ).then((mod) => ({ default: mod.MissingTranslationDialog })),
);

export const MissingTranslationDialog = (props: MissingTranslationDialogProps) => (
    <React.Suspense fallback={null}>
        <LazyMissingTranslationDialog {...props} />
    </React.Suspense>
);
